import Vue from 'vue'
import { ActionTree } from 'vuex'
import { ApiState } from './types'
import { RootState } from '../types'
import config from 'config'
import { matchDefinition } from '@/helpers/utils'
import { Logger } from '@/lib/logger'

export const actions: ActionTree<ApiState, RootState> = {
  async registerUserContent ({ commit }, parameters: { [key: string]: string}) {
    const { endpoint, method, definition } = config.api.endpoints.registerUserConsents
    if (matchDefinition(definition, parameters)) {
      try {
        const response = await Vue.prototype.$api[method](endpoint, parameters)
        return response
      } catch (error) {
        Logger.error(error, 'API', Vue.prototype.$api.apiUrl, 'yellowgreen')()
        commit('SET_ERROR', {
          registeruserconsent: true
        })
      }
    } else {
      Logger.error('Definition did not match call parameters', 'API', { definition, parameters }, 'yellowgreen')()
    }
  },
  async getLegalStatus ({ commit }, parameters: { [key: string]: string }) {
    const { endpoint, method, definition } = config.api.endpoints.getLegalStatus
    if (matchDefinition(definition, parameters)) {
      try {
        const response = await Vue.prototype.$api[method](endpoint, parameters)
        return response
      } catch (error) {
        Logger.error(error, 'API', Vue.prototype.$api.apiUrl, 'yellowgreen')()
        commit('SET_ERROR', {
          getLegalStatus: true
        })
      }
    } else {
      Logger.error('Definition did not match call parameters', 'API', { definition, parameters }, 'yellowgreen')()
    }
  },
  async getLegalUrl ({ commit }, parameters: { [key: string]: string }) {
    const { endpoint, method, definition } = config.api.endpoints.getLegalUrl
    if (matchDefinition(definition, parameters)) {
      try {
        const response = await Vue.prototype.$api[method](endpoint, parameters)
        return response
      } catch (error) {
        Logger.error(error, 'API', Vue.prototype.$api.apiUrl, 'yellowgreen')()
        commit('SET_ERROR', {
          getLegalUrl: true
        })
      }
    } else {
      Logger.error('Definition did not match call parameters', 'API', { definition, parameters }, 'yellowgreen')()
    }
  }
}
